import { render, staticRenderFns } from "./AcceptCoach.vue?vue&type=template&id=6954473a&scoped=true"
import script from "./AcceptCoach.vue?vue&type=script&lang=js"
export * from "./AcceptCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954473a",
  null
  
)

export default component.exports